import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "pb-3 text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Vælg betalingsrate", -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "text-left mb-2 mt-2"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg månedlig eller årlig betaling'
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: "paymentInfo" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 1,
  class: "account pb-5"
}
const _hoisted_11 = { class: "reg-no" }
const _hoisted_12 = { class: "konto-no" }
const _hoisted_13 = { class: "highlights mb-3" }
const _hoisted_14 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopoverComponent = _resolveComponent("PopoverComponent")!
  const _component_RadioComponent = _resolveComponent("RadioComponent")!
  const _component_inputFieldComponent = _resolveComponent("inputFieldComponent")!
  const _component_ButtonTapComponent = _resolveComponent("ButtonTapComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.basketCms.ratePopover)
        ? (_openBlock(), _createBlock(_component_PopoverComponent, {
            key: 0,
            type: "icon",
            class: "page-component__popover text-left",
            buttonClass: "popover__icon popover__icon__questionmark",
            innerData: _ctx.basketCms.ratePopover
          }, null, 8, ["innerData"]))
        : _createCommentVNode("", true),
      (_ctx.missingCalculations.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.missingCalculations), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthYearArray, (item, inx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass([inx + 1 === _ctx.monthYearArray.length ? 'pb-1' : 'pb-2']),
        key: 'rate' + inx
      }, [
        _createVNode(_component_RadioComponent, {
          name: "monthYear",
          id: 'monthYear' + item.value,
          inputValue: item.value,
          preSelect: _ctx.basketModel.choosePackage.monthYear,
          trackingLabel: 'monthYear_' + item.value,
          onRadioComponent: _ctx.chooseMonthYear
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.value === 'M' ? _ctx.monthlyDisplayPrice : _ctx.yearlyDisplayPrice), 1)
          ]),
          _: 2
        }, 1032, ["id", "inputValue", "preSelect", "trackingLabel", "onRadioComponent"])
      ], 2))
    }), 128)),
    (!_ctx.basketModel.pristineStep.get(_ctx.card.name) && !_ctx.basketModel.choosePackage.monthYear)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "pb-5 text-left",
      innerHTML: _ctx.getYearlySavingsTxt()
    }, null, 8, _hoisted_7),
    _createVNode(_TransitionGroup, { name: "slide-simple" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          (!_ctx.basketCms.skipAccountInfo)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "text-left",
                innerHTML: _ctx.card.text
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true),
          (!_ctx.basketCms.skipAccountInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_inputFieldComponent, {
                    id: 'regNo',
                    name: 'regNo',
                    innerData: _ctx.basketModel.payment,
                    placeholder: '4 cifre',
                    label: 'Reg. nr.',
                    validateOnLoad: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
                    required: true,
                    visibleError: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
                    labelPopover: _ctx.basketCms.regNoPopover,
                    class: "text-left"
                  }, null, 8, ["innerData", "label", "validateOnLoad", "visibleError", "labelPopover"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_inputFieldComponent, {
                    id: 'kontoNo',
                    name: 'kontoNo',
                    innerData: _ctx.basketModel.payment,
                    placeholder: 'op til 12 cifre',
                    label: 'Konto nr.',
                    validateOnLoad: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
                    required: true,
                    visibleError: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
                    labelPopover: _ctx.basketCms.accountNoPopover,
                    class: "text-left"
                  }, null, 8, ["innerData", "label", "validateOnLoad", "visibleError", "labelPopover"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: "coverage text-left",
              innerHTML: _ctx.basketCms.paymentBox
            }, null, 8, _hoisted_14)
          ])
        ], 512), [
          [_vShow, _ctx.basketModel.choosePackage.monthYear]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ButtonTapComponent, {
      class: _normalizeClass([_ctx.card.buttonStyle, 'mt-3', { 'btn-disabled': !_ctx.isValid }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextStep())),
      textContent: _toDisplayString(_ctx.card.linkText),
      "data-gtm": _ctx.basketCms.dataGtm,
      "data-gtm-click-text": "order"
    }, null, 8, ["class", "textContent", "data-gtm"])
  ]))
}